import { API_COLUMN_PREFERENCES } from "globals/constants";
import { request, spUrl } from "utils";
import { executeRequest } from "utils/proxy";

/**
 * Module for managing user column preferences via API requests.
 * @module userColumnsPreferences
 */
export const userColumnsPreferences = {
	/**
     * Retrieves user column preferences for a specified table type.
     * @param {string} tableType - The type of table to fetch preferences for.
     * @param {Object} [options] - Optional request configuration options.
     * @returns {Promise} A promise resolving to the API response with column preferences.
     */
	get: (tableType, options) => request(spUrl(`${API_COLUMN_PREFERENCES}?tableType=${tableType}`), options),

	/**
     * Saves user column preferences to the server.
     * @param {Object} payload - The preferences data to save.
     * @param {Object} [options] - Optional fetch configuration overrides.
     * @returns {Promise} A promise resolving to the API response after saving.
     */
	save: (payload, options = {}) => {
		const fetchOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
			...options,
		};

		return executeRequest(spUrl(API_COLUMN_PREFERENCES), fetchOptions, {});
	},
};